module.exports = __webpack_public_path__ + "img/banner1.11594a4e.jpg";